@if (this.order$ | async; as order) {
  @if (this.orderDetailFields$ | async; as orderDetails) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> {{ 'LIB_ORDERS.COMMON.ACTIVITY.TITLE' | translate }} </mat-panel-title>
      </mat-expansion-panel-header>
      @for (info of orderDetails; track activityTrackIndex($index, info)) {
        <ng-container
          *ngTemplateOutlet="info.childFields.length ? multiStep : singleStep; context: { info: info }"
        ></ng-container>
        <ng-template #multiStep let-info="info">
          <mat-accordion [multi]="true">
            <mat-expansion-panel class="no-styling">
              <mat-expansion-panel-header class="no-styling" [collapsedHeight]="'100%'" [expandedHeight]="'auto'">
                <ng-container *ngTemplateOutlet="singleStep; context: { info: info }"></ng-container>
              </mat-expansion-panel-header>
              <mat-divider></mat-divider>
              @for (child of info.childFields; track activityTrackIndex($index, child)) {
                <ng-container
                  *ngTemplateOutlet="singleStep; context: { info: child, isChild: true, compact: true }"
                ></ng-container>
                <mat-divider></mat-divider>
              }
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
        <ng-template #singleStep let-info="info" let-isChild="isChild" let-compact="compact">
          <div class="order-details__list-item row" [ngClass]="{ compact: compact }">
            <div class="detail-left-col">
              {{ info | buildDetailName: isChild | translate }}
            </div>
            <div
              class="order-details__list-item__value show-line-breaks"
              [innerHTML]="info | buildDetailValue: order"
            ></div>
          </div>
        </ng-template>
        <mat-divider class="divider"></mat-divider>
      }
    </mat-expansion-panel>
  }
}
